import { render, staticRenderFns } from "./Books.vue?vue&type=template&id=8a825e0a&scoped=true&"
import script from "./Books.vue?vue&type=script&lang=ts&"
export * from "./Books.vue?vue&type=script&lang=ts&"
import style0 from "./Books.vue?vue&type=style&index=0&id=8a825e0a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a825e0a",
  null
  
)

export default component.exports